"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchDashboardEvent = void 0;
var effects_1 = require("redux-saga/effects");
/**
 * Creates an effect which will dispatch the provided event. Yield whatever this function returns
 *
 * @param event - event to dispatch
 */
function dispatchDashboardEvent(event) {
    return effects_1.put(event);
}
exports.dispatchDashboardEvent = dispatchDashboardEvent;
//# sourceMappingURL=eventDispatcher.js.map